import {Stack, Box, Transition, ActionIcon} from "@mantine/core";
import IconArrowDown from "../../../assets/arrow-down.svg?react";
import {CommandInput} from "../components/CommandInput";
import classes from "./ChatInput.module.css";
import React from "react";

type ChatInputProps = {
    disabled: boolean;
    onSubmit: (message: string) => void;
    showScrollDownButton: boolean;
    scrollRef: React.RefObject<HTMLDivElement | null>;
};

export const ChatInput = ({
    disabled,
    onSubmit,
    showScrollDownButton,
    scrollRef,
}: ChatInputProps) => {
    return (
        <Stack
            gap={0}
            className={classes.inputContainer}
            data-name="chat-input"
        >
            <Box pos="relative">
                <Transition
                    transition="slide-up"
                    mounted={showScrollDownButton}
                >
                    {(transitionStyles) => (
                        <Box
                            style={{
                                ...transitionStyles,
                                position: "absolute",
                                bottom: "calc(100% + 0.5rem)",
                                left: "50%",
                                transform: "translateX(-50%)",
                                zIndex: 2,
                            }}
                        >
                            <ActionIcon
                                variant="filled"
                                color="gneis.0"
                                c="dark.6"
                                bd={"1px solid white"}
                                radius="xl"
                                size="lg"
                                onClick={() => {
                                    scrollRef.current?.scrollTo({
                                        top: scrollRef.current.scrollHeight,
                                        behavior: "smooth",
                                    });
                                }}
                            >
                                <IconArrowDown height={18} />
                            </ActionIcon>
                        </Box>
                    )}
                </Transition>
                <CommandInput
                    variant="chat"
                    disabled={disabled}
                    onSendMessage={onSubmit}
                />
            </Box>
        </Stack>
    );
};
